import { useQuery, useQueryClient } from "react-query";
import { getPositions } from "components/measuring/lib/measuring-data";

export const usePositions = () => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ["positions"],
        queryFn: () => getPositions(),
        staleTime: Infinity,
        enabled: !queryClient.getQueryData(["positions"]),
    });
};
